import React from 'react';
import styled from '@emotion/styled';
import artePropTypes from '../../propTypes';

import { mediaQueries, palette, remCalc, font } from '../../css';

const StyledWrapper = styled('div')(() => ({
    display: 'flex',
    padding: remCalc(20, 0),
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: `1px solid ${palette('primary', 'mainDivider')}`,
}));

const StyledLogo = styled('div')(() => ({
    width: remCalc(110),
    height: remCalc(75),
    background: `url(${process.env.CDN_URL}/img/next-footer/europe.jpg) center center no-repeat`,
    backgroundSize: 'contain',
    [mediaQueries.medium]: {
        width: remCalc(148),
        height: remCalc(100),
    },
}));

const StyledLabel = styled('p')(() => ({
    margin: remCalc(0, 0, 0, 15),
    maxWidth: remCalc(100),
    lineHeight: font.size.s,
    fontSize: font.size.xs,
    fontWeight: font.weight.medium,
    color: palette('white'),
    textAlign: 'center',
}));

export const EuropeanSection = ({ label }) => (
    <StyledWrapper>
        <StyledLogo />
        <StyledLabel>{label}</StyledLabel>
    </StyledWrapper>
);

EuropeanSection.propTypes = artePropTypes.europeanFooter.isRequired;

export default EuropeanSection;
